/*
 * @Author: ç¯çç§æ(Lucas Huang)
 * @Date: 2019-05-23 10:27:07
 * @LastEditors: ç¯çç§æ(Lucas Huang)
 * @LastEditTime: 2019-08-15 10:15:43
 * @QQ: 1055818239
 * @Version: v0.0.1
 */
import { NgModule, ModuleWithProviders } from '@angular/core';
import { DateHelperModule } from '@farris/ui-common/date';
import { NumberHelperModule } from '@farris/ui-common/number';
import { ColumnFormatService } from './column-format.service';
import { ColumnFormatterPipe } from './data-formatter.pipe';

@NgModule({
    imports: [
        DateHelperModule.forRoot(),
        NumberHelperModule.forRoot()
    ],
    exports: [ColumnFormatterPipe],
    declarations: [
        ColumnFormatterPipe
    ],
    providers: [],
})
export class DataColumnModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: DataColumnModule,
            providers: [
                ColumnFormatService
            ]
        };
    }
}
